import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { GenericStatusCount } from "@app/project/store/projects.state";

import { NgChanges } from "@app/shared/model/ng-changes.model";
import { IFilters } from "@app/shared/services/filter.service";

@Component({
    selector: "clare-list-filter-checkbox-group",
    templateUrl: "./list-filter-checkbox-group.component.html",
    styleUrls: ["./list-filter-checkbox-group.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListFilterCheckboxGroupComponent implements OnChanges {
    @Input() statusCounts: GenericStatusCount<string>[];
    @Input() filterColumn: string;
    @Input() initialActiveFilters = [];
    @Input() isRow = false;
    @Input() customizedClasses = "";

    @Output() private changeFilterHandler = new EventEmitter<IFilters>();
    private activeFilters: string[] = [];

    ngOnChanges(changes: NgChanges<ListFilterCheckboxGroupComponent>): void {
        if (changes.initialActiveFilters?.currentValue) {
            this.activeFilters = changes.initialActiveFilters.currentValue;
            this.changeFilterHandler.emit({ [this.filterColumn]: this.activeFilters || [] });
        }
    }

    /**
     * @description Determines whether the given filter is active or not
     * @param {string} filter the filter to check the status of
     * @returns {boolean} is the current filter active?
     */
    isActiveFilter(filter: string): boolean {
        return this.activeFilters?.some(activeFilter => activeFilter === filter);
    }

    /**
     * @description Adds and removes filter keys from the active filters array.
     * Emits a changeFilter event when done.
     * @param {string} filterStr the filter key
     */
    onFilterChange(filterStr: string) {
        const ind = this.activeFilters.findIndex(filter => filter === filterStr);
        if (ind < 0) {
            this.activeFilters.push(filterStr);
        } else {
            this.activeFilters.splice(ind, 1);
        }
        this.changeFilterHandler.emit({ [this.filterColumn]: this.activeFilters || [] });
    }
}
